/**
 * entrySource — remembers HOW the visitor originally arrived for the
 * whole browsing session. Without this, a visitor who lands on the
 * homepage from Facebook and then clicks a story gets logged as
 * "Internal" (the story page's referrer is our own homepage) and the
 * real origin is lost. Captured once on first pageload:
 *   - ?utm_source=... / ?src=...  → "utm:<tag>"
 *   - external document.referrer → the referrer URL
 *   - nothing / same-site        → "direct"
 */
const KEY = "storylo_entry_ref";

export function captureEntrySource() {
  try {
    if (sessionStorage.getItem(KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const utm = params.get("utm_source") || params.get("src") || "";
    if (utm) { sessionStorage.setItem(KEY, `utm:${utm}`); return; }
    const ref = document.referrer || "";
    let internal = false;
    try { internal = !!ref && new URL(ref).host === window.location.host; }
    catch (_e) { internal = false; }
    sessionStorage.setItem(KEY, ref && !internal ? ref : "direct");
  } catch (_e) { /* storage blocked — tolerated */ }
}

export function entrySource() {
  try { return sessionStorage.getItem(KEY) || ""; } catch (_e) { return ""; }
}
